import { createContext, useContext, useState, useEffect } from 'react';
import { auth as authApi, getToken, setToken, removeToken } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { checkAuth(); }, []);

  async function checkAuth() {
    const token = getToken();
    if (!token) { setLoading(false); return; }
    try {
      const res = await authApi.me();
      if (res.success && res.data) setUser(res.data);
      else removeToken();
    } catch {}
    finally { setLoading(false); }
  }

  async function login(email, password) {
    const res = await authApi.login(email, password);
    if (res.success && res.data) {
      setToken(res.data.token);
      setUser(res.data.user);
      return { success: true };
    }
    return { success: false, error: res.error || 'Login failed' };
  }

  async function register(email, password, display_name) {
    const res = await authApi.register(email, password, display_name);
    if (res.success && res.data) {
      setToken(res.data.token);
      setUser(res.data.user);
      return { success: true };
    }
    return { success: false, error: res.error || 'Registration failed' };
  }

  async function logout() {
    removeToken();
    setUser(null);
  }

  async function refreshUser() {
    const res = await authApi.me();
    if (res.success && res.data) setUser(res.data);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}